/**
 * External dependencies
 */
import React from "react";
import { Box } from "@towersystems/towersystems-design-system";
import { get } from "lodash";

/**
 * Internal dependencies
 */
import useReportBuilder from "modules/report-builder/use-report-builder";
import FormInputCheckbox from "components/forms/form-checkbox";

const ConfigurePoints = () => {
  const { report, editReport } = useReportBuilder();

  const handleChange = (e) => {
    editReport({ config: { points: !get(report, "config.points") } });
  };

  return (
    <Box>
      <FormInputCheckbox
        onChange={handleChange}
        label="Show points"
        checked={!!get(report, "config.points")}
      />
    </Box>
  );
};

export default ConfigurePoints;
